import type { CommandId } from "./commandIds.js";

/** Bubbling app-level command event (WEB notes: central command bus). */
export const NPP_COMMAND_EVENT = "npp:command";

export type CommandSource = "menu" | "keyboard" | "api";

export type NppCommandDetail = {
  commandId: CommandId | string;
  source: CommandSource;
};

export function emitCommandEvent(
  target: EventTarget,
  detail: NppCommandDetail,
): void {
  target.dispatchEvent(
    new CustomEvent(NPP_COMMAND_EVENT, {
      bubbles: true,
      composed: true,
      detail,
    }),
  );
}
